(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["single-addon"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('.missy-free-light-addon:not([data-ready])');

    roots.forEach((root) => {
      root.dataset.ready = 'true';

      const eligibleIds = root.dataset.eligibleVariantIds
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);
      const eligibleColors = (root.dataset.eligibleColors || '')
        .split(',')
        .map((value) => value.trim().toLowerCase())
        .filter(Boolean);
      const eligibleSizes = (root.dataset.eligibleSizes || '')
        .split(',')
        .map((value) => value.trim().toLowerCase())
        .filter(Boolean);
      let giftId = Number(root.dataset.giftVariantId);
      let giftAvailable = root.dataset.giftAvailable === 'true';
      const freeWhenEligible = root.dataset.freeWhenEligible === 'true';
      const defaultSelected = root.dataset.defaultSelected === 'true';
      const formId = root.dataset.productFormId;
      const sectionId = root.dataset.sectionId;
      const form = document.getElementById(formId);
      const toggle = root.querySelector('[data-addon-toggle]');
      const dialog = root.querySelector('.missy-free-light-addon__dialog');
      const track = root.querySelector('[data-media-track]');
      const dots = root.querySelector('[data-media-dots]');
      const count = root.querySelector('[data-media-count]');
      const quickPrice = root.querySelector('[data-quick-current-price]');
      const quickComparePrice = root.querySelector('[data-quick-compare-price]');
      const regularPrice = root.querySelector('[data-addon-regular-price]');
      const freeComparePrice = root.querySelector('[data-addon-free-compare-price]');
      const addonVariantSelect = root.querySelector('[data-addon-variant-select]');
      const addonImage = root.querySelector('.missy-free-light-addon__image img');
      let currentMedia = 0;
      let pointerStart = 0;

      const setSelected = (selected) => {
        if (!giftAvailable) selected = false;
        root.dataset.selected = String(selected);
        toggle?.setAttribute('aria-checked', String(selected));
        root.querySelectorAll('[data-addon-form-field]').forEach((field) => {
          field.disabled = !selected;
        });
        document.dispatchEvent(new CustomEvent('product-addon:change', { detail: { formId } }));
      };

      const getSelectedOptions = () => {
        const picker = document.getElementById(`variant-selects-${sectionId}`);
        if (!picker) return [];

        return Array.from(picker.querySelectorAll('input[type="radio"]:checked, select'))
          .map((input) => input.value?.trim().toLowerCase())
          .filter(Boolean);
      };

      const isEligible = (variantId) => {
        if (eligibleIds.includes(String(variantId))) return true;

        const selectedOptions = getSelectedOptions();
        const colorMatches = !eligibleColors.length || eligibleColors.some((color) => selectedOptions.includes(color));
        const searchableSize = `${root.dataset.productTitle || ''} ${selectedOptions.join(' ')}`.toLowerCase();
        const sizeMatches = !eligibleSizes.length || eligibleSizes.some((size) => searchableSize.includes(size));
        return colorMatches && sizeMatches;
      };

      const updateState = (variantId) => {
        if (!giftAvailable) {
          root.dataset.state = 'sold-out';
          setSelected(false);
          return;
        }

        const eligible = isEligible(variantId);
        root.dataset.state = eligible && freeWhenEligible ? 'included' : 'choose';
        quickPrice.textContent = eligible && freeWhenEligible
          ? '$0.00'
          : root.querySelector('.missy-free-light-addon__regular-price').textContent.trim();

        if (!root.dataset.userSelected) setSelected(eligible && defaultSelected);
      };

      toggle?.addEventListener('click', () => {
        root.dataset.userSelected = 'true';
        setSelected(root.dataset.selected !== 'true');
      });

      addonVariantSelect?.addEventListener('change', () => {
        const selectedOption = addonVariantSelect.selectedOptions[0];
        if (!selectedOption) return;

        giftId = Number(selectedOption.value);
        giftAvailable = selectedOption.dataset.available === 'true';
        root.dataset.giftVariantId = String(giftId);
        root.dataset.addonVariantIds = String(giftId);
        root.dataset.giftAvailable = String(giftAvailable);

        root.querySelectorAll('[data-addon-form-field][name$="[id]"]').forEach((field) => {
          field.value = String(giftId);
        });

        const price = selectedOption.dataset.price || '';
        if (regularPrice) regularPrice.textContent = price;
        if (freeComparePrice) freeComparePrice.textContent = price;
        if (quickComparePrice) quickComparePrice.textContent = price;
        const imageSrc = selectedOption.dataset.imageSrc;
const imageSrcset = selectedOption.dataset.imageSrcset;
const imageAlt = selectedOption.dataset.imageAlt;

if (addonImage && imageSrc) {
  if (imageSrcset) {
    addonImage.srcset = imageSrcset;
  } else {
    addonImage.removeAttribute('srcset');
  }

  addonImage.src = imageSrc;
  addonImage.alt = imageAlt || '';
}

        const selectedProductId = form?.querySelector('[name="id"]')?.value;
        updateState(selectedProductId);
        document.dispatchEvent(new CustomEvent('product-addon:change', { detail: { formId } }));
      });

      const descriptionVideo = root.querySelector('[data-description-source] video');
      const hasMediaVideo = Boolean(track?.querySelector('[data-media-type="video"], [data-media-type="external_video"]'));

      if (descriptionVideo && !hasMediaVideo) {
        const slide = document.createElement('div');
        const clonedVideo = descriptionVideo.cloneNode(true);
        slide.className = 'missy-free-light-addon__media-slide';
        slide.dataset.mediaType = 'video';
        clonedVideo.controls = true;
        clonedVideo.playsInline = true;
        clonedVideo.preload = 'metadata';
        slide.appendChild(clonedVideo);
        track.appendChild(slide);
      }

      const slides = Array.from(track?.querySelectorAll('.missy-free-light-addon__media-slide') || []);

      const pauseVideos = () => {
        slides.forEach((slide) => {
          slide.querySelectorAll('video').forEach((video) => video.pause());
        });
      };

      const showMedia = (index) => {
        if (!slides.length) return;
        currentMedia = (index + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (currentMedia * 100) + '%)';
        pauseVideos();

        Array.from(dots.children).forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', String(dotIndex === currentMedia));
        });

        const type = slides[currentMedia].dataset.mediaType === 'video' ? 'Video' : 'Image';
        count.textContent = type + ' ' + (currentMedia + 1) + ' of ' + slides.length;
      };

      slides.forEach((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'View media ' + (index + 1));
        dot.addEventListener('click', () => showMedia(index));
        dots.appendChild(dot);
      });

      if (slides.length < 2) {
        root.querySelectorAll('[data-media-prev], [data-media-next], [data-media-dots]').forEach((element) => {
          element.hidden = true;
        });
      }

      root.querySelector('[data-media-prev]')?.addEventListener('click', () => showMedia(currentMedia - 1));
      root.querySelector('[data-media-next]')?.addEventListener('click', () => showMedia(currentMedia + 1));

      root.querySelector('[data-media-viewer]')?.addEventListener('pointerdown', (event) => {
        pointerStart = event.clientX;
      });

      root.querySelector('[data-media-viewer]')?.addEventListener('pointerup', (event) => {
        const distance = event.clientX - pointerStart;
        if (Math.abs(distance) > 45) showMedia(currentMedia + (distance < 0 ? 1 : -1));
      });

      const featureList = root.querySelector('[data-feature-list]');
      const featureItems = Array.from(root.querySelectorAll('[data-feature-source] li'));
      const featureIcons = Array.from(root.querySelectorAll('[data-feature-icons] [data-icon-url]'))
        .map((item) => item.dataset.iconUrl)
        .filter(Boolean);

      featureItems.forEach((sourceItem, index) => {
        const item = document.createElement('li');
        const icon = document.createElement('span');
        const text = document.createElement('span');
        icon.className = 'missy-free-light-addon__feature-icon';
        icon.setAttribute('aria-hidden', 'true');
        if (featureIcons[index]) {
          const image = document.createElement('img');
          image.src = featureIcons[index];
          image.alt = '';
          icon.appendChild(image);
        } else {
          icon.textContent = '✓';
        }
        text.textContent = sourceItem.textContent.trim();
        item.append(icon, text);
        featureList.appendChild(item);
      });

      root.querySelector('[data-open-quick-view]')?.addEventListener('click', () => {
        showMedia(0);
        dialog?.showModal();
      });

      root.querySelector('[data-close-quick-view]')?.addEventListener('click', () => {
        pauseVideos();
        dialog?.close();
      });

      dialog?.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        pauseVideos();
        dialog.close();
      });

      const selectedId = form?.querySelector('[name="id"]')?.value;
      if (selectedId) updateState(selectedId);

      document.addEventListener('product:variant-change', (event) => {
        if (String(event.detail?.sectionId) !== String(sectionId)) return;
        delete root.dataset.userSelected;
        updateState(event.detail?.variant?.id);
      });

      document.getElementById(`variant-selects-${sectionId}`)?.addEventListener('change', () => {
        window.setTimeout(() => {
          const nextVariantId = form?.querySelector('[name="id"]')?.value;
          updateState(nextVariantId);
        }, 0);
      });

      root.querySelectorAll('[data-color]').forEach((button) => {
        button.addEventListener('click', () => {
          const picker = document.getElementById(`variant-selects-${sectionId}`);
          if (!picker) return;

          const target = Array.from(picker.querySelectorAll('input[type="radio"], option'))
            .find((input) => input.value?.toLowerCase() === button.dataset.color.toLowerCase());

          if (!target) return;

          if (target.tagName === 'OPTION') {
            const select = target.closest('select');
            select.value = target.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            const targetLabel = Array.from(picker.querySelectorAll('label[for]'))
              .find((label) => label.htmlFor === target.id);

            if (targetLabel) {
              targetLabel.click();
            } else {
              target.click();
            }
          }
        });
      });

    });
  })();

(() => {
  if (window.glercProductAddonsReady) return;
  window.glercProductAddonsReady = true;

  const getControls = (form) => {
    const formId = form.getAttribute('id');
    return Array.from(document.querySelectorAll('.product-addon-control[data-selected="true"]'))
      .filter((control) => control.getAttribute('data-product-form-id') === formId);
  };

  const getAddonItems = (form) => {
    const items = [];
    const seen = new Set();

    getControls(form).forEach((control) => {
      const ids = (control.dataset.addonVariantIds || '')
        .split(',')
        .map((id) => Number(id.trim()))
        .filter(Boolean);

      ids.forEach((id) => {
        if (seen.has(id)) return;
        seen.add(id);
        items.push({
          id,
          quantity: 1,
          properties: { _promotion: control.dataset.promotionLabel || 'Product add-on' }
        });
      });
    });

    return items;
  };

  const syncAdditionalItems = (form) => {
    form.querySelectorAll('[data-product-addon-field]').forEach((field) => field.remove());

    getAddonItems(form).forEach((item, itemIndex) => {
      const index = itemIndex + 1;
      const fields = [
        [`shopify-additional-items[${index}][id]`, item.id],
        [`shopify-additional-items[${index}][quantity]`, item.quantity]
      ];

      fields.forEach(([name, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = String(value);
        input.dataset.productAddonField = 'true';
        form.appendChild(input);
      });
    });
  };

  const syncAllForms = () => {
    document.querySelectorAll('.product-addon-control[data-product-form-id]').forEach((control) => {
      const form = document.getElementById(control.dataset.productFormId);
      if (form) syncAdditionalItems(form);
    });
  };

  const renderCart = (state) => {
    const targets = [
      { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
    ];

    targets.forEach((target) => {
      const container = document.getElementById(target.id);
      const html = state.sections?.[target.section];
      if (!container || !html) return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const replacement = container.querySelector(target.selector) || container;
      const incoming = parsed.querySelector(target.selector);
      if (incoming) replacement.innerHTML = incoming.innerHTML;
    });

    if (typeof CartDrawer !== 'undefined') new CartDrawer();
    if (typeof Cart !== 'undefined') new Cart().renderContents(state);

    const drawer = document.getElementById('Cart-Drawer');
    if (drawer) {
      document.body.classList.add('open-cc');
      drawer.classList.add('active');
      document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    }
  };

  const addSelectedItems = async (event, form) => {
    if (!(form instanceof HTMLFormElement) || !form.id) return;

    syncAdditionalItems(form);
    const addonItems = getAddonItems(form);

    const variantId = Number(form.querySelector('[name="id"]')?.value);
    if (!variantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (form.dataset.addonsBusy === 'true') return;
    form.dataset.addonsBusy = 'true';

    const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
    submitButtons.forEach((button) => {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
    });

    const rootUrl = window.Shopify?.routes?.root || '/';
    const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value || 1));
    const sections = ['main-cart', 'cart-drawer', 'cart-bubble'];

    try {
      const uniqueAddonItems = addonItems
        .filter((item, index, items) => items.findIndex((candidate) => candidate.id === item.id) === index)
        .map((item) => ({ ...item, quantity: item.quantity * quantity }));
      const items = [{ id: variantId, quantity }, ...uniqueAddonItems];

      const response = await fetch(`${rootUrl}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items, sections, sections_url: window.location.pathname })
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message);

      renderCart(state);
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: state.items?.[0] } }));
    } catch (error) {
      const wrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
      const message = wrapper?.querySelector('.product-form__error-message');
      if (wrapper && message) {
        message.textContent = error.message;
        wrapper.hidden = false;
      }
    } finally {
      form.dataset.addonsBusy = 'false';
      submitButtons.forEach((button) => {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
      });
    }
  };

  window.addEventListener('click', (event) => {
    const button = event.target.closest('button[name="add"], input[name="add"], #AddToCart');
    if (!button) return;
    const form = button.form || button.closest('form');
    if (!form || !getControls(form).length) return;
    addSelectedItems(event, form);
  }, true);

  window.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (submitter && !submitter.matches('button[name="add"], input[name="add"], #AddToCart')) return;
    if (!getControls(event.target).length) return;
    addSelectedItems(event, event.target);
  }, true);

  document.addEventListener('product-addon:change', syncAllForms);

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.attributeName === 'data-selected')) syncAllForms();
  });
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-selected'],
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllForms, { once: true });
  } else {
    syncAllForms();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
